/**
 * Fonctions de diagnostique des performances
 */
const disablePerformanceMode = true;

export default function launch() {
    console.perfLog = function () {};
    if (disablePerformanceMode) return;

    console.perfLog = (componentAndMethodName) => {
        try {
            console.log("%c" + componentAndMethodName, "color: #388E3C"); // eslint-disable-line no-console
        } catch (error) {
            //C'est pas grave si ça échoue
        }
    };
}

export function getCurrentFunctionName() {
    let re = /([^(]+)@|at ([^(]+) \(/g;

    let sCallerName;
    {
        let st = new Error().stack;
        let aRegexResult = re.exec(st);
        //re.lastIndex = 0;
        aRegexResult = re.exec(st);
        sCallerName = aRegexResult ? aRegexResult[1] || aRegexResult[2] : "Navigateur non supporté";
    }

    return sCallerName;
}
